module.exports = "/_next/static/images/MaximizeReturn@2x-8c1da05b0c3dcf2bfc4b9fc4382db9e3.png";